import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const NewsStream = Loadable({
    loader: () => import(/* webpackChunkName: "NewsStream" */ './newsStream'),
    loading: () => <div />,
});
export const BigImage = Loadable({
    loader: () => import(/* webpackChunkName: "BigImage" */ './newsStream/components/BigImage'),
    loading: () => <div />,
});
export const NoImage = Loadable({
    loader: () => import(/* webpackChunkName: "NoImage" */ './newsStream/components/NoImage'),
    loading: () => <div />,
});
export const OneImage = Loadable({
    loader: () => import(/* webpackChunkName: "OneImage" */ './newsStream/components/OneImage'),
    loading: () => <div />,
});
export const ThreeImage = Loadable({
    loader: () => import(/* webpackChunkName: "ThreeImage" */ './newsStream/components/ThreeImage'),
    loading: () => <div />,
});
export const Stick = Loadable({
    loader: () => import(/* webpackChunkName: "Stick" */ './newsStream/components/Stick'),
    loading: () => <div />,
});
export const TwoImage = Loadable({
    loader: () => import(/* webpackChunkName: "TwoImage" */ './newsStream/components/TwoImage'),
    loading: () => <div />,
});
